import { render } from "./EventsGrid.vue?vue&type=template&id=b18eff54&scoped=true"
import script from "./EventsGrid.vue?vue&type=script&lang=js"
export * from "./EventsGrid.vue?vue&type=script&lang=js"

import "./EventsGrid.vue?vue&type=style&index=0&id=b18eff54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b18eff54"]])

export default __exports__